import { render, staticRenderFns } from "./UserStats.vue?vue&type=template&id=4303afe2&"
import script from "./UserStats.vue?vue&type=script&lang=js&"
export * from "./UserStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports